import { LanguagesType } from "shared/locale";

type IDescriptionType = Record<string, Record<LanguagesType, string>>

const descriptionForPayment: IDescriptionType = {}

export const getDescriptionByCurrentPayment = ({ lang, paymentKey }: { lang: LanguagesType; paymentKey: string }) => ({
  __html: descriptionForPayment[paymentKey]?.[lang],
})
